// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LicenseDetailsHeader__wrapper___yqbbS","caption":"LicenseDetailsHeader__caption___zHP2i"};